/**
 * PromptKeyCard
 *
 * Card for a prompt key in the grid view. Shows display name,
 * prompt key, live version badge, and draft indicator.
 */

import React from 'react';
import VersionBadge from '../../shared/VersionBadge';
import type { PromptKeySummary } from '../../types/prompt';

interface PromptKeyCardProps {
  summary: PromptKeySummary;
  onClick: () => void;
}

const PromptKeyCard: React.FC<PromptKeyCardProps> = ({ summary, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full text-left rounded-lg border bg-white p-4 hover:border-blue-300 hover:shadow-sm transition-all h-[120px] flex flex-col"
    >
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-semibold text-sm truncate">{summary.displayName}</h3>
        {summary.liveVersion && <VersionBadge status="live" />}
      </div>
      <p className="text-xs text-gray-400 font-mono truncate">{summary.promptKey} <span className="text-gray-300">· {summary.taxonomyKey}</span></p>
      <div className="mt-auto">
        <p className={`text-xs mb-1 ${summary.hasDraft ? 'text-amber-600' : 'invisible'}`}>
          Draft pending
        </p>
        <p className="text-xs text-gray-500">
          {summary.liveVersion
            ? <>v{summary.liveVersion}</>
            : <span className="text-gray-400">No versions</span>
          }
        </p>
      </div>
    </button>
  );
};

export default PromptKeyCard;
